// Monta o cardápio em seções (uma por categoria) a partir da lista completa de itens da API.

// Mesmo formato de produto usado no resto do app (carrinho, folha, edição do admin).
// idCategoria é a categoria real do item; antes vinha do bloco "Todos" da resposta (id 1),
// e a tela de edição já abria com a categoria errada selecionada.
export const paraProduto = (item) => ({
  id: item.id,
  nome: item.nome,
  preco: item.preco,
  imagem: item.imagens?.map((img) => img.urlS3) || [],
  receita: item.receita,
  subCategory: item.categorias?.[0]?.descricao || null,
  descricao: item.categorias?.map((cat) => cat.descricao) || [],
  idCategoria: item.categorias?.[0]?.id ?? null,
  categorias: item.categorias || [],
});

// A API devolve blocos [{ nomeCategoria, itens }]; sem filtro de categoria vem um bloco só
// ("Todos"), mas junta todos por garantia e remove repetidos.
export const itensDaResposta = (blocos) => {
  const vistos = new Set();
  const itens = [];
  (blocos || []).forEach((bloco) =>
    (bloco.itens || []).forEach((item) => {
      if (vistos.has(item.id)) return;
      vistos.add(item.id);
      itens.push(paraProduto(item));
    })
  );
  return itens;
};

// Busca sem diferenciar maiúsculas nem acentos ("acai" acha "Açaí").
export const normalizar = (texto) =>
  (texto || "")
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

export const filtrarProdutos = (produtos, termo) => {
  const t = normalizar(termo);
  if (!t) return produtos;
  return produtos.filter(
    (p) => normalizar(p.nome).includes(t) || normalizar(p.receita).includes(t) || p.descricao.some((d) => normalizar(d).includes(t))
  );
};

// Uma seção por categoria, na ordem das categorias do restaurante. Item em mais de uma
// categoria aparece em cada uma (como nos apps de delivery). Item sem categoria vai para "Outros".
export const montarSecoes = (produtos, categorias) => {
  const secoes = (categorias || []).map((c) => ({ id: String(c.id), nome: c.nome, produtos: [] }));
  const porId = new Map(secoes.map((s) => [s.id, s]));
  const outros = { id: "outros", nome: "Outros", produtos: [] };

  produtos.forEach((p) => {
    const destinos = (p.categorias || []).map((c) => porId.get(String(c.id))).filter(Boolean);
    if (destinos.length === 0) outros.produtos.push(p);
    destinos.forEach((s) => s.produtos.push(p));
  });

  return [...secoes, outros].filter((s) => s.produtos.length > 0);
};
